module.exports = __webpack_public_path__ + "img/only-text.40011ba4.png";